/*eslint-disable*/
import React from 'react'
import { withFormik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';
import sha1 from 'sha1'
import MyRole from '../../apiInputComponent/myRole';
import MyBranchMultiple from '../../apiInputComponent/myBranchMultiple';
import putAxios from '../../axiosComponent/put';
import { MyCheckBox } from '../../apiInputComponent/myInput'
import MyBusinessCategory from '../../apiInputComponent/myBusinessCategory';
import cogoToast from 'cogo-toast'


const AddUsers = ({ values, errors, touched, isSubmitting, handleSubmit, handleClose }) => {
    return (
        <>
            <Modal.Content>
                <Container>
                    <div className="ui form">
                        <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Role</label>
                                <Fieldmik component={MyRole} name="roleId" placeholder="select Role" customizedRole={true} />
                                {touched.role && errors.role ? <Label size="mini" prompt pointing>{errors.role}</Label> : ''}
                            </FormUi.Field>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Employee Code</label>
                                <Fieldmik name="employeeCode" placeholder="Code" />
                                {touched.employeeCode && errors.employeeCode ? <Label size="mini" prompt pointing>{errors.employeeCode}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group>
                        <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Name</label>
                                <Fieldmik name="name" placeholder="Name" />
                                {touched.name && errors.name ? <Label size="mini" prompt pointing>{errors.name}</Label> : ''}
                            </FormUi.Field>
                            {/* <FormUi.Field >
                                <label className="labelName p-bold-600">&nbsp;</label>
                                <Fieldmik name="role" placeholder="Name" />
                                {touched.role && errors.role ? <Label size="mini" prompt pointing>{errors.role}</Label> : ''}
                            </FormUi.Field> */}
                            {/* <FormUi.Field>
                                <label className="labelName p-bold-600">Nick Name</label>
                                <Fieldmik name="nickName" placeholder="Name" />
                                {touched.nickName && errors.nickName ? <Label size="mini" prompt pointing>{errors.nickName}</Label> : ''}
                            </FormUi.Field> */}
                        </FormUi.Group>
                        <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Username</label>
                                <Fieldmik name="username" placeholder="username" />
                                {touched.username && errors.username ? <Label size="mini" prompt pointing>{errors.username}</Label> : ''}
                            </FormUi.Field>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Password</label>
                                <Fieldmik type="password" name="password" placeholder="password" />
                                {touched.password && errors.password ? <Label size="mini" prompt pointing>{errors.password}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group>
                        <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Email Id</label>
                                <Fieldmik name="emailId" placeholder="Email" />
                                {touched.emailId && errors.emailId ? <Label size="mini" prompt pointing>{errors.emailId}</Label> : ''}
                            </FormUi.Field>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Mobile Number</label>
                                <Fieldmik maxLength="10" name="mobile" placeholder="Mob. No." />
                                {touched.mobile && errors.mobile ? <Label size="mini" prompt pointing>{errors.mobile}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group>
                        {/* <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Office Phone</label>
                                <Fieldmik maxLength="10" name="officePh" placeholder="Phone" />
                                {touched.officePh && errors.officePh ? <Label size="mini" prompt pointing>{errors.officePh}</Label> : ''}
                            </FormUi.Field>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Reporting Manager</label>
                                <Fieldmik name="reportingManger" placeholder="" />
                                {touched.reportingManger && errors.reportingManger ? <Label size="mini" prompt pointing>{errors.reportingManger}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group>
                        <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Reporting Manager Email Id</label>
                                <Fieldmik name="managerEmail" placeholder="Email" />
                                {touched.managerEmail && errors.managerEmail ? <Label size="mini" prompt pointing>{errors.managerEmail}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group> */}
                            {/* <FormUi.Field>
                                <label className="labelName p-bold-600">Branch</label>
                                <Fieldmik component={MyBranchMultiple} name="branch" placeholder="Branch" />
                                {touched.branch && errors.branch ? <Label size="mini" prompt pointing>{errors.branch}</Label> : ''}
                            </FormUi.Field> */}
                        {/* <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Business Category</label>
                                <Fieldmik component={MyBusinessCategory} name="businessCategory" placeholder="" />
                                {touched.businessCategory && errors.businessCategory ? <Label size="mini" prompt pointing>{errors.businessCategory}</Label> : ''}
                            </FormUi.Field>
                        </FormUi.Group> */}
                        {/* <FormUi.Group>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">Email Alert</label>
                                <Fieldmik type="checkbox" name="emailAlert" placeholder="Email Alert" />
                            </FormUi.Field>
                            <FormUi.Field>
                                <label className="labelName p-bold-600">SMS Alert</label>
                                <Fieldmik type="checkbox" name="smsAlert" placeholder="SMS Alert" />
                            </FormUi.Field>
                        </FormUi.Group> */}
                    </div>
                </Container>
            </Modal.Content>
            <Modal.Actions>
                {isSubmitting ? 'Loading...' : ''}
                <Button onClick={handleClose} type="submit" size="tiny">Cancel</Button>
                <Button disabled={isSubmitting} onClick={handleSubmit} size="tiny" primary>Submit</Button>
            </Modal.Actions>
        </>
    )
}

const FormikAddUsers = withFormik({
    mapPropsToValues({ roleId, employeeCode, name, nickName, username, password, emailId, mobile, officePh, reportingManger, managerEmail, branch, businessCategory, emailAlert, smsAlert }) {
        return {
            roleId: roleId || '',
            employeeCode: employeeCode || '',
            name: name || '',
            nickName: nickName || '',
            username: username || '',
            password: password || '',
            emailId: emailId || '',
            mobile: mobile || '',
            officePh: officePh || '',
            reportingManger: reportingManger || '',
            managerEmail: managerEmail || '',
            branch: branch || '',
            businessCategory: businessCategory || '',
            emailAlert: emailAlert,
            smsAlert: smsAlert,
        }
    },
    validationSchema: yup.object().shape({
        roleId: yup.string().required('Role Required'),
        employeeCode: yup.string().min(3, 'Must be more than 3 Letters').required(' Required'),
        name: yup.string().min(3, 'Must be more than 3 Letters').required(' Required'),
        nickName: yup.string().min(3, 'Must be more than 3 Letters'),
        username: yup.string().min(3, 'Must be more than 3 Letters').required(' Required'),
        password: yup.string().min(3, 'Must be more than 3 Letters').required(' Required'),
        emailId: yup.string().email('Invalid Email').required(' Required'),
        mobile: yup.string().matches(/^[0][1-9]\d{9}$|^[1-9]\d{9}$/g, "Invalid Mobile Number Eg: 9999888777").required(' Required'),
        officePh: yup.string().matches(/^[0][1-9]\d{9}$|^[1-9]\d{9}$/g, "Invalid Office Phone Eg: 9999888777"),
        reportingManger: yup.string().min(3, 'Must be more than 3 Letters'),
        managerEmail: yup.string().email('Invalid Email'),
        branch: yup.string(),
        businessCategory: yup.number(),
    }),

    handleSubmit(values, { setErrors, setSubmitting, setSuccess }) {
        console.log("USer Values", values)
        setSubmitting(true)
        let roleId = values.roleId
        
        function getRoleName(role){
            switch(role){
                case 2: 
                    return "Administrator";
                case 3:
                    return "Approver";
            }
        }

        let role = getRoleName(values.roleId)

        let realName = values.name
        let nickName = values.nickName
        let username = values.username
        let password = values.password
        let employeeCode = values.employeeCode.toUpperCase()
        let email = values.emailId
        let phone = values.mobile
        let officePhone = values.officePh
        let reportingManger = values.reportingManger
        let reportingEmail = values.managerEmail
        let businessCategoryId = values.businessCategory
        let branchId = []
        // values.branch.map((o,i) => {
        //     let temp = {}
        //     temp.branchId = values.branch[i]
        //     branchId[i] = temp
        // })
        let smsAlert = values.smsAlert === true ? 1 : 0
        let emailAlert = values.emailAlert === true ? 1 : 0

        putAxios({
            url: 'masters/userMaster',
            createItems: {
                role: role,
                roleId: roleId,
                realName: realName,
                nickname: nickName,
                userName: username,
                password: password,
                userCode: employeeCode,
                email: email,
                mobileNo: phone,
                officePhone: officePhone,
                reportingManager: reportingManger,
                reportingEmail: reportingEmail,
                businessCategoryId: businessCategoryId,
                branchData: branchId,
                smsAlert: smsAlert,
                emailAlert: emailAlert,
                status: 1

            },}).then
            ((data) => {
                if (data.data.status == 200 ) {
                    cogoToast.success(data.data.message)
                    setTimeout(() => {
                        window.location.href = "/users" 
                    }, 1000);
                   
                    setSubmitting(false)
                }else if(data.data.status == 204 ){
                    setTimeout(() => {
                        cogoToast.success(data.data.message)
                    },500);
                    setSubmitting(false)
                }
                else {
                    cogoToast.error(data.data.message)
                    setSubmitting(false)
                }
            }
            )
    }
})(AddUsers)

export default FormikAddUsers
